module.exports = __webpack_public_path__ + "img/statsy.396185d0.svg";